import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import md5 from 'md5';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import * as Sentry from '@sentry/browser';
import {
  ONESKY_LOCALE_MAPPING,
  ONESKY_API_KEY,
  ONESKY_SECRET_KEY,
  ONESKY_PROJECT_ID,
  ONESKY_SOURCE_FILE_NAME,
} from 'appenv';
import { availableLocales } from 'models/localization';
import commonResources from './resources';

// Reference: https://github.com/onesky/api-documentation-platform#authentication
const getLocaleTranslations = async (locale: string) => {
  const oneskyLocale = ONESKY_LOCALE_MAPPING[locale];
  const timeStamp = moment().unix();
  const oneskyUrl = `https://platform.api.onesky.io/1/projects/${ONESKY_PROJECT_ID}/translations?api_key=${ONESKY_API_KEY}&timestamp=${timeStamp}&dev_hash=${md5(timeStamp + ONESKY_SECRET_KEY)}&locale=${oneskyLocale}&source_file_name=${ONESKY_SOURCE_FILE_NAME}`;

  try {
    const response = await axios.get(oneskyUrl);

    return response.data;
  } catch (error) {
    console.warn(error);
    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Warning);
      Sentry.captureException(error);
    });
    return {};
  }
};

export const setupI18nConfigForLocale = async (locale: string) => {
  const translations = await getLocaleTranslations(locale);

  if (!isEmpty(translations)) {
    i18n.addResourceBundle(locale, 'translation', translations, true, true);
  }
};

const defaultLang = availableLocales[0];

i18n
  .use(initReactI18next)
  .init({
    resources: commonResources,
    lng: defaultLang,
    fallbackLng: {
      'zh-Hant': ['zh-Hans', 'zh', 'en'],
      'zh-Hans': ['zh-Hant', 'zh', 'en'],
      default: [defaultLang],
    },
    interpolation: {
      escapeValue: false,
      prefix: '%{',
      suffix: '}',
    },
    react: {
      bindI18nStore: 'added',
    },
  }).then(() => {
    // Fetch translations for default language on page load
    setupI18nConfigForLocale(defaultLang);
  });

export default i18n;
